import { render, staticRenderFns } from "./SIMCARD.vue?vue&type=template&id=89b397a8&"
import script from "./SIMCARD.vue?vue&type=script&lang=js&"
export * from "./SIMCARD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports